/**
 * Created by fers on 05.02.16.
 */
import AppPanel from '../fw/AppPanel.react';
import React from 'react';
import PropTypes from 'prop-types';
import Relay from 'react-relay';
import {injectIntl, defineMessages, FormattedMessage, IntlShape} from 'react-intl';

import types from '../../common/model-api/types';
import urlMapping from '../app/URLMapping';

import Editor from '../fw/Editor.react';
import {wrapNotFound} from '../app/NotFoundHandler.react';
import ChannelHeader from './ChannelHeader.react';
import {getLastOrganisationId} from '../app/LastOrganisationId';
import * as Permission from '../../common/util/Permission';
import * as BrowserPermission from '../BrowserPermission';
import { User } from '../../common/types/types';

const messages = defineMessages({
    title: {id: 'channelEdit.title', 'defaultMessage': 'Editing application'},
	save: {id: 'channelEdit.save', 'defaultMessage': 'Save custom name'}
});

interface ChannelEditProps {
    intl: IntlShape;
    user: User;
}

class ChannelEdit extends React.Component<ChannelEditProps> {

    static propTypes = {
        intl: PropTypes.object.isRequired,
        user: PropTypes.object.isRequired,
    };
    typeName = 'channels';

    constructor() {
        super();
    }

    render() {
        let data = this.props.user.organisation.channel;
        let type = types[this.typeName];

        let columns = {
            'name': {},
        };

        if (BrowserPermission.hasPermission(Permission.PERM_INSTANCE_ADMIN) && BrowserPermission.developerModeEnabled()) {
            columns['rateLimit'] = {};
        }

        return (
            <AppPanel breadcrumbParams={[
                {type, data},
                {type: types['organisations'], data: this.props.user.organisation}]
            } title={this.props.intl.formatMessage(messages.title)}>
				<ChannelHeader data={data} organisation={this.props.user.organisation}>
					<h3><FormattedMessage defaultMessage="Custom name" id="application.customName" /> {data.name}</h3>
				</ChannelHeader>
                <Editor
						buttonTitle={this.props.intl.formatMessage(messages.save)}
						cancelable
                        columns={columns}
                        data={data}
                        fatQuery={Relay.QL `fragment on UpdateChannelPayload {
                            updatedNode {
                                id,
                                cachingStatus,
                                channelDef_id,
                                metadata,
                                activated,
                                enabled,
                                rateLimit,
                                channelDef {
                                    id
                                },
                                organisation_id,
                                name,
                                description,
                                type,
                            },
                        }`}
                        metadata={type}
                        mutation={Relay.QL `mutation { updateChannel }`}
                        organisationId={data.organisation_id}
                        urlMapping={urlMapping}
                />
            </AppPanel>
        );
    }
}


export default Relay.createContainer(wrapNotFound(injectIntl(ChannelEdit), (props) => {
    return props.user.organisation && props.user.organisation.channel;
}), {
    initialVariables: {
        organisationId: '',
        channelId: '',
    },
    prepareVariables (variables) {
		if (!variables.organisationId) {
            variables.organisationId = getLastOrganisationId();
        }

        return variables;
    },
    fragments: {
        user: () => Relay.QL`
            fragment on User {
                organisation(id: $organisationId) {
                    id,
                    realId,
                    name,
                    channel(id: $channelId) {
                        id,
                        organisation_id,
                        channelDef {
                            id,
                            name,
                            icon
                        },
                        type,
                        rateLimit,
                        cachingStatus,
                        name,
                        description,
                        enabled,
                        activated,
                    }
                },
            }
        `,
    },
});
